import React 			from 'react';
import PropTypes 		from 'prop-types';
import BLComponent 		from '../../../core/_BLComponent.jsx';

export default function BDPSeriesFAQ() {
	return [
				{
					id: 0
				,	title: 'About the Program'
				,	allOpen: true
				, items: [
						{
							id: 0
						,	open: true
						,	question: "What is the new BrickLink Designer Program?"
						,	answer: `We announced the BrickLink Designer Program Series 1, a fresh opportunity for LEGO fans to continue submitting digital designs to be realized as a BrickLink Designer Program set. All approved designs will have the opportunity to be crowdfunded with preorders.`
						}
					,	{
							id: 1
						,	open: true
						,	question: "What are the key dates for each BDP Series?"
						,	answer: `You can find all key dates on the <a href="${blapp.url2.getCrowdProjectMainUrl()}">BrickLink Designer Program homepage</a>.`
						}
					,	{
							id: 2
						,	open: true
						,	question: "How many designs will be produced as BrickLink Designer Program sets per series?"
						,	answer: `Each Series will feature 5 designs for crowdfunding and production. That number may change in future Series instances.`
						}
					,	{
							id: 3
						,	open: true
						,	question: "How many of the sets in each Series will be realized?"
						,	answer: `Up to 5 designs will be chosen for crowdfunding. All designs that reach the 3,000 pre-order minimum threshold will be produced.`
						}
					,	{
							id: 4
						,	open: true
						,	question: "What is the difference with the BrickLink Designer Program Series versus the original 2021 Invitational?"
						,	answer: `<p class="l-margin-bottom">We share the background and what is different this time in our announcement post. Some key differences include:</p>
						<div class="crowd-help__table-container"><table class="crowd-help__table">
						<tr><th>2021 Invitational</th><th>BDP Series</th></tr>
						<tr>
							<td>Invited existing 10k Club projects from LEGO IDEAS to compete to be crowdfunded and produced.</td>
							<td>An open invitation for anyone to submit designs that follow our Submission Guidelines.</td>
						</tr>
						<tr>
							<td>Produced up to 10,000 of each set.</td>
							<td>Will produce a limited production of each set.</td>
						</tr>
						<tr>
							<td>Required sets to compete against each other to be the first 5 crowdfunded.</td>
							<td>Will approve 5 sets for crowdfunding. Every one of those five sets that reaches the crowdfunding threshold will be produced as a limited edition BDP set.</td>
						</tr>
						<tr>
							<td></td>
							<td><p class="l-margin-bottom">Fan designers have a greater responsibility to mature their designs by following each BDP Series Submission Guidelines.</p>
<p>All submissions must be made in BrickLink Studio, and the Studio files themselves must meet certain requirements in how they are set up.</p></td>
						</tr>
						</table></div>`
						}
					,	{
							id: 5
						,	open: true
						,	question: "Why did the requirements change this time?"
						,	answer: `BrickLink Designer Program Series draws from what we learned during the 2021 Invitational; both from fan designers and internal processes. We have adjusted the program accordingly.`
						}
					,	{
							id: 6
						,	open: true
						,	question: "What prompted the change from before, where you took LEGO IDEAS 10k Club projects to now where you are taking an open submission?"
						,	answer: `We really want to promote digital building with BrickLink Studio. There is endless creativity when building virtually, and we know that virtual building leads to physical building. In this way, we encourage new builds and new submissions. If you have a 10k Club model, you are also welcome to submit it to the BrickLink Designer Program Series once you have adapted the model to follow the Submission Guidelines and only use elements from the Series Palette.`
						}
					,	{
							id: 7
						,	open: true
						, urlHash: 'participating-countries'
						,	question: "Will there be geographical limitations to participating in BrickLink Designer Program Series?"
						,	answer: `BrickLink Designer Program is open to participants who <a href="#will-you-ship-the-bricklink-designer-sets-to-all-countries">live in a country</a> where the LEGO Group and BrickLink both operate. Countries that are not eligible to participate as designers in BDP are Russia, Belarus, North Korea, Syria, Iran, Cuba, Libya and Iraq. You can only buy a BrickLink Designer Program set if you live in a country where the <a href="https://www.lego.com/en-us" target="_blank">LEGO Shop</a> ships to. As LEGO Shop expands its presence to more countries, so will BDP. `
						}
					,	{
							id: 8
						,	open: true
						,	question: "Are there any age limitations to designing for the BrickLink Designer Program?"
						,	answer: `You must be at least 18 years old to submit to the BrickLink Designer Program. The model builder themselves must also be at least 18 years old.`
						}
					,	{
							id: 9
						,	open: true
						,	question: "What is the difference between a BrickLink Designer Program set and a standard LEGO set?"
						,	answer: `<p class="l-margin-bottom">BrickLink Designer Program sets are designed by LEGO fans, for experienced builders. We’re giving LEGO fans the opportunity to be the Fan Designer of their own set from start to finish. Therefore we provide detailed <a href="${blapp.url2.getCrowdProjectGuidelinesUrl()}">Submission Guidelines</a>.</p>
						<p class="l-margin-bottom">LEGO sets from the standard assortment are designed by LEGO designers following our own extensive internal design processes.</p>
						<p>This means the sets fans purchase will have a building experience much closer to how the fan designer originally intended it, where LEGO IDEAS sets for instance are fan ideas re-imagined by LEGO designers. For this reason, BDP sets can be more challenging as we do not apply LEGO design standards as rigorously to the design and the building instruction steps.</p>`
						}
					,	{
							id: 10
						,	open: true
						,	question: "Will you be doing more BDP Series in the future? How often?"
						,	answer: `Yes. While we are not committing to exact timeframes, we do anticipate accepting submissions up to three times per year on a rolling basis. This means while the previous series sets are in production, we may be accepting submissions for the next series.`
						}
					]
				}
			, {
					id: 1
				,	title: 'Creating Your Designs'
				,	allOpen: false
				, items: [
						{
							id: 0
						,	open: false
						,	question: "What are the submission requirements for each BDP Series?"
						,	answer: `<p class="l-margin-bottom">You must build your submission as a digital model using the BrickLink Studio app. All submissions must use the BDP Palette of elements. By default we do not accept submissions with elements that are not found in the BDP Palette.</p>
						<p>There are also detailed requirements that cover theme, size, part selection, part usage, stability, submodels, building experience, working models, stressing the elements, Minifigures, and stickers. For complete requirements, please refer to the <a href="${blapp.url2.getCrowdProjectGuidelinesUrl()}">Submission Guidelines</a>.</p>`
						}

					,	{
							id: 1
						,	open: false
						,	question: "How many bricks are in each BDP Series Palette?"
						,	answer: `The palette for each series has around 8,500 unique part-color combinations of elements. The amount of parts for each Series will vary based on the projected part availability when the set is produced.`
						}
					,	{
							id: 2
						,	open: false
						,	question: "Why are we limited only to bricks in the BDP Palette?"
						,	answer: `The BDP Palette is the collection of elements that will be available for production when the BDP sets will be produced in the factory. Our partners in Production plan which elements will be available at what times. As BDP sets are made in a small, limited batch, element availability depends on the larger LEGO Group portfolio and production schedule.`
						}
					,	{
							id: 3
						,	open: false
						,	question: "Should we factor in part cost when designing our models?"
						,	answer: `No. Don’t worry about the part price listed in the Studio app when you are designing;this will not affect your model price or how we consider it as a potential finalist. The pricing shown in the Studio app is reflective of BrickLink average pricing and is unrelated to the actual cost for the LEGO Group to produce a part.`
						}
					,	{
							id: 4
						,	open: false
						,	question: "Is it possible to check whether an existing model has all the elements used in it available in the BDP Palette, so I don’t have to completely rebuild it?"
						,	answer: `<p class="l-margin-bottom">Follow these steps to check the element availability in the BDP Palette:</p>
						<ol class="number-list l-margin-bottom">
							<li>Import the model into BrickLink Studio.</li>
							<li>Select the current BDP Series palette.</li>
							<li>On the right-hand toolbar, under Step List, click the filter icon.</li>
							<li>Turn the filter on and select "unavailable within the selected palette."</li>
						</ol>
						<p class="l-margin-bottom">This will highlight part colors that are not available in the BDP Palette.</p>
						<div class="crowd-guidelines-image">
							<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/file-setup/digital-building_step-2_color-palette@2x.png"/>
						</div>`
						}
					,	{
							id: 5
						,	open: false
						,	question: "The guidelines for use of Minifigure parts are specific. Are there any exceptions?"
						,	answer: `<p class="l-margin-bottom">Our goal with the Minifigure guidelines is to ensure a submission is not entirely reliant on minifigs.</p>
						<ul class="bullet-list l-margin-bottom">
							<li>Skeleton legs and arms may be used as individual parts not connected to a skeleton minifigure.</li>
							<li>Minifigure torsos, legs and hands are restricted to minifigure use only.</li>
							<li>Unprinted minifigure heads, and minifigure heads printed as an object (e.g. pineapple, globe, pumpkin) may be used and are not subject to the "each minifigure head may only be used once" limit. Skeleton heads are also not restricted in use.</li>
							<li>Torsos may be re-used, regardless of whether they are printed.</li>
							<li>Minifigures used as statues or mannequins will count toward the minifigure limit guidelines. Skeletons also do not count toward the limit.</li>
						</ul>
						<p>All designs will be reviewed by the BDP Design Team. Please use your own judgement on what would be acceptable given the information provided.</p>`
						}
					,	{
							id: 6
						,	open: false
						,	question: "How do I see what parts are available in what colors in the BDP Palette?"
						,	answer: `<p class="l-margin-bottom">In the Shapes view, you will see a plus sign + in the upper right corner of some bricks. This is a “drawer,” click the + and expand it into the available colors for that shape.</p>
						<div class="crowd-guidelines-image">
							<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/colors/expand-or-collapse-colors.png" style="width:1277px"/>
						</div>
						<p class="l-margin-bottom">If you want to see all parts available in one color, use the Colors categorization:<p>
						<div class="crowd-guidelines-image">
							<img src="//${blapp.config.getHost( "static2" )}/img/bdp/series-1-images/colors/colors-category.png" style="width:1277px"/>
						</div>`
						}
					]
			}
			, {
				id: 2
			,	title: 'Submitting Your Designs'
			,	allOpen: false
			, items: [
					{
						id: 0
					,	open: false
					,	question: "How many designs may I submit?"
					,	answer: `Fan Designers may submit multiple designs to any BDP Series, but only one design per Fan Designer will be considered for crowdfunding and production in any one BDP Series.`
					}
				,	{
						id: 1
					,	open: false
					,	question: "May I collaborate with another designer and submit together?"
					,	answer: `Yes, you make work collaboratively with 1 partner. If your design is selected as a finalist, both designers will be required to sign individual contracts, with one designer taking the lead role for communication with the BDP team. Compensation can only be split 50/50 between designers.`
					}
				,	{
						id: 2
					,	open: false
					,	question: "How do I submit my design?"
					,	answer: `You will be able to submit your design during the Submission Intake phase for each series.`
					}
				,	{
						id: 3
					,	open: false
					,	question: "During the submission process, will you give me feedback on whether my submission qualifies, and have some time to make fixes if I accidentally did not follow one of the submission requirements?"
					,	answer: `We will do our best to come back with feedback during the submission process, however once the submission process is done, we will no longer be able to provide feedback. Please submit your designs as early as possible and make sure to reference the submission guidelines while creating your design.`
					}
				,	{
						id: 4
					,	open: false
					,	question: "Who owns my design once I’ve submitted it to the program?"
					,	answer: `Once you submit a model to the BrickLink Designer Program, you are agreeing to the Terms of Service stating that from the time you submit, to the time we announce the 5 selected designs, the LEGO Group will own the rights to your design. If your design is chosen, we will present you with the fan designer contract, in which the LEGO Group will be assigned the rights. You must sign this to move forward into crowdfunding. If your design is not chosen, all rights to the design will revert to you.`
					}
				,	{
						id: 5
					,	open: false
					,	question: "What happens to the designs that are not approved?"
					,	answer: `If you've submitted a model and it is not approved for crowdfunding, all rights to the design revert to you. You may then use the design for any purpose you like.`
					}
				,	{
						id: 6
					,	open: false
					,	question: "If I submitted a project to LEGO IDEAS that reached 10,000 supporters and was NOT approved, or if my project expired before reaching 10k, may I submit to BrickLink Designer Program?"
					,	answer: `Yes. If your submission meets the relevant BDP Series Submission Guidelines, you may submit a design already submitted to LEGO IDEAS, provided it has either reached 10k and was NOT approved, or it has Expired and is no longer active on LEGO IDEAS. You may not submit a design that is currently active on LEGO IDEAS. You MAY NOT delete an active model from LEGO Ideas to submit to BDP.`
					}
				,	{
						id: 7
					,	open: false
					,	question: "If I submitted to a previous BrickLink Designer Program but my model was not selected or crowdfunded and produced, may I submit it again?"
					,	answer: `Yes. If your submission meets the current BDP Series Submission Guidelines, you may submit a design that participated in a previous BrickLink Designer Program but was not selected as a finalist or achieved crowdfunding. According to the Terms of Service, you may submit a design to BDP a maximum of 2 times in the same format, however if you make improvements or change your model in a significant manner you can continue to submit your model to future Series. The idea is to allow Fan Designers to continue improving their model with feedback received from the fan community and BDP staff. Please note this is subject to the BDP staff’s discretion and we may ask for additional changes if the model is deemed to be “too similar” on the third or fourth submissions.`
					}
				,	{
						id: 9
					,	open: false
					,	question: "The Submission Guidelines say I must create building instructions of my model in Studio. Why is that, and how do I do that?"
					,	answer: `We ask that you create building instructions of your model so it is easy for our team to test build the models as we evaluate them and test them for production. The Guidelines have some pointers on creating instructions. You can also see the <a href="https://studiohelp.bricklink.com/hc/en-us" target="_blank">Studio Help pages</a> and the <a href="https://forum.bricklink.com/" target="_blank">Studio Forum</a> to learn more.`
					}
				,	{
						id: 10
					,	open: false
					,	question: "Must my Studio building instructions be complete when I submit my model?"
					,	answer: `Yes, building instructions must be complete to a certain level before the submission date. They do not need all the bells and whistles of published instructions, but they must have step inventories, and they must be clear enough to build from.`
					}
				,	{
						id: 11
					,	open: false
					,	question: "May I build the model physically and submit pictures?"
					,	answer: `We encourage you to build your model physically to test its play functions and stability, and you can include those in the supporting materials of your submission. Note that you must submit a Studio file with building instructions as the Guidelines require. The main image of your model must also be a render.`
					}
				,	{
						id: 12
					,	open: false
					,	question: "Can my Studio model be divided into multiple files representing different build stages?"
					,	answer: `You may only upload ONE file per submission. Your Studio file can contain multiple layers of submodels, so it isn’t necessary to use multiple files for a single model, except where you need a workaround to create building instructions. Submitting multiple files causes problems for us, so it is best to get everything into one file. Contact us at <a href="mailto:bdpsupport@lego.com">BDPsupport@lego.com</a> or write on the BrickLink <a href="https://forum.bricklink.com/viewforum.php?f=13&sid=24ac69d3ca1c299c473c58a1e9bf495e" target="_blank">Designer Program Forum</a> if you are having trouble with this.`
					}
				,	{
						id: 13
					,	open: false
					,	question: "What is meant by building in submodels?"
					,	answer: `<p class="l-margin-bottom">You must break up your model into submodels that make sense for building instructions. Note: Do not release submodels after you are done building. Keep the submodels intact within the model file.</p>
					<p>For <a href="https://studiohelp.bricklink.com/hc/en-us/articles/5625432131863-Submodel" target="_blank">information</a> on Submodels, see <a href="https://studiohelp.bricklink.com/hc/en-us/sections/5847371350935-Submodels" target="_blank">Studio Help page</a>.</p>`
					}
				,	{
						id: 14
					,	open: false
					,	question: "How do I represent stickered parts in my submission? Do I use the blank part, or do I create a version of the part with the sticker in Parts Designer and submit that?"
					,	answer: `<p class="l-margin-bottom">You may only upload ONE file per submission, so please insert your stickered parts into your submission. When uploading, you will be asked whether your design contains stickers, and how many. This will help us identify the submissions with stickers and process them appropriately.</p>
					<p>It is helpful if you can make stickered parts in <a href="${blapp.url2.getPartDesignerDownloadUrl()}">PartDesigner</a> to show us exactly where they belong. You should also include a list of any stickers (plus their design files) in your supporting documents.</p>`
					}
				,	{
						id: 15
					,	open: false
					,	question: `The guidelines say "Don't use Intellectual Property (IP) that belongs to anyone else." Can we create models that look substantially similar to a branded item but under a different name and without identifying markings on stickers?`
					,	answer: `We encourage you to design original models that do not resemble or are not inspired by any existing IP. If a model looks too similar to someone else’s IP, to the point where the rights holder could make a case that it can easily be confused (for example, same dimensions, identifying elements, and color scheme) then it would not be approved.`
					}
				,	{
						id: 16
					,	open: false
					,	question: "Are we allowed to submit something like a Creator 3-in-1 set, where one can build multiple models with a single selection of parts?"
					,	answer: `No. Please limit each submission to a single model design.`
					}

				,	{
						id: 17
					,	open: false
					,	question: "Are people who have already sold their designs in some form eligible to submit to BrickLink Designer Program?"
					,	answer: `Anyone who has retained the IP rights to their design and has not licensed them out to a third party may submit to the BrickLink Designer Program. When you submit to the BDP, you are licensing the rights to produce your submission to the LEGO Group. If your design is not selected, those rights are released back to you. During the time you have licensed the rights, you must pause any sales of your model, if applicable, including building instructions and custom kits. Once the rights are released back to you, you may resume your own sales. `
					}
				,	{
						id: 18
					,	open: false
					,	question: "Can you be selected as a Finalist more than once? Are there limits to being selected as a Finalist? "
					,	answer: `Starting with Series 7, Fan Designers may only be selected as a Finalist once per calendar year. In earlier series, there was not a limit. While we love our repeat Finalists and their creations, we're setting this limit to ensure more people have the opportunity to be selected and see their sets produced. `
					}
				]
			}
			, {
					id: 3
				,	title: 'Crowd Validation and Review'
				,	allOpen: false
				, items: [
						{
							id: 0
						,	open: false
						,	question: "What is crowd validation?"
						,	answer: `During the crowd validation period, we invite all BrickLink members to vote for their favorite submissions. We will weigh these votes alongside our internal selection criteria to influence what designs we ultimately choose for crowdfunding and production.`
						}
					,	{
							id: 1
						,	open: false
						,	question: "How are you reviewing the submissions and how do the vote totals influence the finalist choices?"
						,	answer: `We’re looking at a combination of the public reaction, as expressed by votes received during Crowd Validation, and the designer’s capabilities. We also look at the future LEGO Group portfolio. Finally, we seek to ensure a variety of themes and price points so each round can have a little something for everyone.`
						}
					,	{
							id: 2
						,	open: false
						,	question: "If my design is selected for Crowdfunding, how will I be notified?"
						,	answer: `We will notify the five finalist fan designs via email using the email address on file for your BrickLink account. You will be invited to a meeting with the BDP Design Team to discuss the next steps, and have five (5) days to notify the BDP Design Team you would like to proceed. The BDP Design Team will then share with you a formal contract. You will have ten (10) days to sign the contract or let us know you are not interested in participating further.`
						}
					,	{
							id: 3
						,	open: false
						,	question: "What happens between Review and Crowdfunding? Why does that take so long?"
						,	answer: `<p class="l-margin-bottom">After Crowd Voting, the BDP Design Team works with fan designers to refine the models to meet our requirements for model safety, stability, and building experience</p>
<p>We also refine the building instructions and modify the models in case an element from the BDP Palette will no longer be available for production. This is something we do everything to avoid, but is ultimately outside our control.</p>`
						}
					,	{
							id: 4
						,	open: false
						,	question: "Will you modify the original fan design during the process?"
						,	answer: `We do not intend to change the original designs that are loved by the fans. There can be inevitable modifications due to production requirements, such as part availability, product safety and stability issues. All design revisions will be done by the original fan designer.`
						}
				]
			}
			, {
					id: 4
				,	title: 'Crowdfunding'
				,	allOpen: false
				, items: [
						{
							id: 0
						,	open: false
						,	question: `What does "crowdfunding" mean?`
						,	answer: `Crowdfunding means we're raising funds from individual pre-orders to test demand before producing the sets in the factory. If at least 3,000 people pre-order the set, it will be considered "crowdfunded," and we will manufacture the item. Please note that set price, official photos of the model and detailed information will go live on the first of the month prior to the month of Crowdfunding. For example, if a Series begins crowdfunding on June 6th, the price and photos will go live on May 1st.`
						}
					,	{
							id: 1
						,	open: false
						,	question: `How long is each crowdfunding period?`
						,	answer: `Each crowdfunding period will be 3-4 weeks`
						}
					,	{
							id: 2
						,	open: false
						,	question: `What is the difference between crowdfunding and normal LEGO Shop orders?`
						,	answer: `When you order on the LEGO Shop, your set is already manufactured and ready to ship. With crowdfunding, the sets have not yet been manufactured. This means it will take about 6 months after you place your order until you receive your set.`
						}
					,	{
							id: 3
						,	open: false
						,	question: `Do fan designers receive a percentage of sales?`
						,	answer: `Yes. Fan designers receive five percent of the net sales price of BDP sets that are sold.`
						}
					,	{
							id: 4
						,	open: false
						,	question: `Do fan designers receive copies of their sets?`
						,	answer: `Yes, finalists whose designs are crowdfunded will receive 5 copies of their sets. `
						}
					,	{
							id: 5
						,	open: false
						,	question: `How can I pre-order a set?`
						,	answer: `When crowdfunding begins, visit the BrickLink Designer Program site, find your desired set, and click the "Pre-order on LEGO.com” button. You will be prompted to sign into your BrickLink account if you're not signed in already. Once you're signed in, you will be re-directed to a LEGO.com cart check out page. You can either check out or go back to bricklink.com to add more sets to your cart.`
						}
					,	{
							id: 6
						,	open: false
						,	question: `How do I get updates about when pre-ordering is happening? I don’t want to miss a chance to get these limited edition sets.`
						,	answer: `<p class="l-margin-bottom">The best way to get alerts about pre-ordering opportunities is to make sure you turn on marketing emails. Go to My BrickLink > Settings > My Contact Settings. Scroll to the bottom and make sure "Newsletter" is checked. We send out email notifications to people who have opted in to marketing messages from us.</p>
						<p>We also suggest you follow BrickLink on <a href="https://www.facebook.com/bricklink/" target="_blank">Facebook</a>, <a href="https://www.instagram.com/bricklink/" target="_blank">Instagram</a>, and <a href="https://twitter.com/bricklink" target="_blank">Twitter</a>.</p>`
						}
					,	{
							id: 7
						,	open: false
						,	question: `How many pre-orders are required for a set to be produced?`
						,	answer: `A minimum of 3,000 pre-orders need to be received during the crowdfunding period to qualify for production.`
						}
					,	{
							id: 8
						,	open: false
						,	question: `How many sets can I pre-order?`
						,	answer: `Pre-orders are limited to two copies of each set per household. We received feedback during the 2021 Invitational that many buyers want to order two sets so they can build one and keep the other sealed in its box. We restrict the limit a household can buy in order to be fair to all of our fans. If you’ve already reached that limit through previous orders your entire order may be cancelled.`
						}
					,	{
							id: 9
						,	open: false
						,	question: `Once you have selected the sets for a Series, when will you share pricing? `
						,	answer: `We will announce the pricing one month before Crowdfunding, so people can plan what they want to purchase during pre-ordering. Please note that the pricing you see on BrickLink is representative of the country your BrickLink account is currently set to, which is reflected by the country flag next to the displayed price.`
						}
					,	{
							id: 10
						,	open: false
						,	question: `What will happen to my pre-order when the project I supported is not realized?`
						,	answer: `When a project is not realized by the end of the crowdfunding period, all pre-orders will be canceled, and you will not be charged.`
						}
					,	{
							id: 11
						,	open: false
						,	question: `What happens to approved sets that don’t reach the crowdfund goal in time?`
						,	answer: `As a fan designer, if your set is one of the five selected for crowdfunding and does not reach the crowdfunding goal in the allotted time, all rights to the design revert to you. You may then use the design for any purpose you like.`
						}
					,	{
							id: 12
						,	open: false
						,	question: `I got an alert on the crowdfunding pages that mentioned I'm currently in a location where BDP sets cannot ship to. What can I do?`
						,	answer: `<p class="l-margin-bottom">BrickLink Designer Program only ships to certain countries. See the list of countries we ship to. Our website determines your location based on IP address, or if you are signed in, by using the address in your account settings. If you’re not located in a country we ship do, the price will be shown in USD.</p>
						<p>You can proceed to click on "Pre-order on LEGO.com” button if you choose a shipping address in a country to which we ship.</p>`
						}
					,	{
							id: 13
						,	open: false
						,	question: `Are Bricklink Designer Program sets eligible for LEGO Insiders points and Gift with Purchase on LEGO.com?`
						,	answer: `Yes, Bricklink Designer Program sets do qualify for Insiders points, but they are not eligible for Gift with Purchase or LEGO Insiders Rewards redemptions for physical items. You may use LEGO Insiders points for payment for BDP sets.`
						}
					,	{
							id: 14
						,	open: false
						,	question: `When will I be charged? How can I make sure my order goes through smoothly without any problems?`
						,	answer: `<p class="l-margin-bottom">Payments are handled differently depending on the payment method you choose. Please read the below carefully and decide whether you pay via credit card or PayPal.</p>
						<p class="l-margin-bottom">Note that your payment provider will temporarily hold the amount needed to pay for your entire order, called a payment authorization, which is a temporary hold of funds that lasts from several days up to one month depending on your issuer. You can read more about that <a href="https://www.lego.com/service/help/online_shop/online_shop/all-about-payment-authorizations-kA009000001Jz6nCAC" target="_blank">here</a>.</p>
						<p class="l-margin-bottom--sm"><strong>Credit Card</strong></p>
						<p class="l-margin-bottom">If you pay via credit card, please choose a card with an expiration date that’s after the anticipated ship date. Then you can avoid having to update your credit card information or risk us having issues with charging you when it’s time for your order to ship.</p>
						<p class="l-margin-bottom">You will only be charged if this project is crowdfunded (receives at least 3,000 pre-orders) and once the product is shipped to you.</p>
						<p class="l-margin-bottom--sm"><strong>PayPal</strong></p>
						<p class="l-margin-bottom">We cannot change the shipping address on PayPal orders. If you place an order with the incorrect shipping address, you will need to contact <a href="https://www.lego.com/service" target="_blank">Customer Service</a> and change your payment method to credit card. Only then will Customer Service be able to update the shipping address on your behalf. Alternatively, you can cancel a PayPal order with the incorrect shipping address if you no longer want it.</p>
						<p class="l-margin-bottom">We cannot add items to your order or increase the quantity of items on orders with PayPal as the payment method as this would cause the original authorization amount to increase. If you want to increase the quantity of an item, you will need to contact <a href="http://lego.com/service" target="_blank">Customer Service</a> and change your payment method to credit card. Then you will be able to increase the order quantity if available</p>
						<p>If your PayPal payment method is declined, <a href="http://lego.com/service" target="_blank">Customer Service</a> can try to re-authorize the PayPal payment. If it fails a second time, we can offer to update the payment method to a credit or debit card.</p>
						`
						}
				]
			}
			, {
					id: 5
				,	title: 'Production and Shipping'
				,	allOpen: false
				, items: [
						{
							id: 0
						,	open: false
						,	question: `How long will it take from when I place my order to when my set is shipped and I receive it?`
						,	answer: `<p class="l-margin-bottom">At the time of your order, the set will have not been manufactured yet. These are called pre-orders, and it will take approximately 6 months from when you order it to the time it ships and you receive it. The set is produced in the factory before being sent to distribution centers around the world and ultimately shipped to you.</p>
						<p>Please note that Asia-Pacific countries will always have a slight delay in shipping compared to the EU and North America as we do not hold the sets in warehouses after they are manufactured like typical LEGO sets. BDP sets are shipped to customers as soon as they are produced to shorten the pre-order time as much as possible. The first sets that are manufactured are sent to the Asia-Pacific markets, but it is a longer journey to get to those markets.</p>`
						}
					,	{
							id: 1
						,	open: false
						,	question: `For the last BrickLink Designer Program, one of the major problems was how long it took for sets to be shipped to buyers around the world. Did this change for BDP Series 1?`
						,	answer: `<p class="l-margin-bottom">Yes, it did. We have moved the time for pre-ordering closer to the time of production for each BDP Series. The pre-ordering dates are set as close as possible to when we need to get final numbers to the factory and tell them how many sets to produce. From there, it will still take about six months for the set to get to you.</p>
<p>By shortening this timeframe, we also see it will help reduce the number of credit card holds, expired credit cards, and billing address changes we need to process. This should make your experience as a customer smoother. We have also added several methods for customers to update payment and mailing addresses during this time, which will be communicated to customers after they pre-order.</p>`
						}
					,	{
							id: 2
						,	open: false
						,	question: `Will there be printed building instructions?`
						,	answer: `<p class="l-margin-bottom">No, the building instructions will be available in a digital form.</p>
<p class="l-margin-bottom">Designer Program sets will feature digital building instructions provided by the LEGO® Builder app. Digital instructions not only reduce cost, they help us fulfil our Planet Promise by using less paper and saving on shipping weight, which in turn reduces emissions while delivering your set to you.</p>
<p>PDF building instructions will also be made publicly available when sets begin shipping.</p>`
						}
					,	{
							id: 3
						,	open: false
						,	question: `Will the sets be suitable for children?`
						,	answer: `The official target audience is 18+ so we do not recommend these sets for children.`
						}
					,	{
							id: 4
						,	open: false
						,	question: `Where will the sets be shipped from?`
						,	answer: `The designer sets will be manufactured in Europe and shipped from global distribution centers.`
						}
					,	{
							id: 5
						,	open: false
						,	question: `Will you ship the BrickLink Designer sets to all countries?`
						,	answer: `<p class="l-margin-bottom">The BrickLink Designer Program sells through the LEGO.com Shop. This allows us to give you a smooth shipping and support process. Unfortunately, this also limits the countries to which we can ship. Only BrickLink members from the following 35 countries are allowed to pre-order the designer sets.</p>
<p class="l-margin-bottom">America: USA, Canada, Mexico</p>
<p class="l-margin-bottom">Europe: UK, Germany, Belgium, Italy, France, Spain, Denmark, Poland, Sweden, Netherlands, Norway, Hungary, Finland, Switzerland, Austria, Portugal, Slovenia, Ireland, Slovakia, Czechia, Luxembourg, Latvia, Lithuania, Estonia, Greece, Romania.</p>
<p class="l-margin-bottom">Asia/Oceania: South Korea, Japan, Australia, New Zealand, Singapore, Malaysia*</p>
<p>Please note that LEGO.com will not ship to Post Office Boxes (PO Boxes) or mail forwarding addresses.</p>
<p class="text--small l-margin-top--xl">*Due to new regulations starting in 2024, customers in Malaysia will not be able to purchase any BDP sets that fall under the 500MYR threshold.</p>`
						}
					,	{
							id: 6
						,	open: false
						,	question: `How much will shipping cost?`
						,	answer: `Shipping costs will follow LEGO.com standards for each country.`
						}
					,	{
							id: 7
						,	open: false
						,	question: `I have an issue with my BDP order or need to update my payment information or shipping address. Who should I contact?`
						,	answer: `Once an order has been placed, you should contact LEGO Service at <a href="http://www.lego.build/service">LEGO.build/service</a> for any order related issues. Do not contact BDP Support, which is only for general program and model design issues. The BDP Support team cannot assist with order related issues.`
						}
					,	{
							id: 8
						,	open: false
						,	question: `I have a question about the program and my model design that’s not on this document. Where can I contact you for a response?`
						,	answer: `Please contact us at <a href="mailto:bdpsupport@LEGO.com">BDPsupport@LEGO.com</a> or via the <a href="https://forum.bricklink.com/viewforum.php?f=13&sid=275872312bdb877b1372a3ec3a8d56d7" target="_blank">BDP Forum</a> for any questions about the BrickLink Designer Program itself or your model design.`
						}
				]
			}
		];
}


